import { AppStoreFR, FrankIcon } from "../../assets/images/FrankIcons";
import facebookIcon from "../../assets/images/facebokIcon.png";
import instaIcon from "../../assets/images/InstaIcon.png";
import linkedInIcon from "../../assets/images/linkedInIcon.png";
import playSore from "../../assets/images/FrankIcons/PlayStore-btn.png";
import mobileFooterNewImage from "../../assets/images/FrankIcons/molbile_footer_img.png";
import { useNavigate } from "react-router-dom";
export default function CustomMobileFooter() {

const navigate = useNavigate();
  // const redirectToStore = () => {
    
  //   const userAgent = navigator.userAgent || navigator.vendor;
  
  //   if (/android/i.test(userAgent)) {
  //     // Redirect to Google Play Store
  //     window.location.href = 'https://play.google.com/store/apps/details?id=com.frankc2c';
  //   } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
  //     // Redirect to Apple App Store
  //     window.location.href = 'https://apps.apple.com/us/app/frank/id6502341979';
  //   } else {
  //     // Handle cases where the OS is not Android or iOS
  //     console.log('This feature is only available on mobile devices.');
  //   }
  // };
  return (
    <div className="diagonal-box" style={{ 
       paddingLeft:"10px",paddingRight:'10px',borderRadius:"24px 24px 0px 0px" }}>
      <div style={{ padding: "0px 30px 0px 20px" }}>
       
        <div style={{    display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column' }}>
          <div
            style={{
              rowGap: 20,
              display: "flex",
              flexDirection: "column",
              zIndex: 111,
              padding: 30,
              justifyContent:'center',
              alignItems:'center'
            }}
          >
            <div style={{display:'flex',justifyContent:"center",alignItems:'center'}}>
              <FrankIcon height={80} color={"#fff"} fill={"#fff"} />
            </div>
            <p
              className="heading-two"
              style={{
                fontSize: "24px",
                textAlign: "center",
                color: "#fff",
                padding: "0px 10px 0px 10px",
                fontFamily: "montserrat-Bold",
                
                margin: 0,
              }}
            >
              Téléchargez l'application<br/> mobile Frank
            </p>
            <p
              style={{
                fontFamily: "montserrat-Medium",
                margin: 0,
                color: "#fff",
                paddingLeft: 5,
                fontSize:18,
                textAlign:'center'
              }}
            >
              Rejoignez gratuitement la <br/>communauté de livraison verte
            </p>

            <div
              className="display-flex"
              style={{
                flexDirection: "row",
                gap: 10,
              }}
            >
              <a
                href="https://apps.apple.com/app/frank/id6502341979"
                target="_blank"
                rel="noreferrer"
              >
                <AppStoreFR height={40} />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.frankc2c"
                target="_blank"
                rel="noreferrer"
                style={{ textAlign: "center" }}
              >
                <img
                  src={playSore}
                  alt="google-play"
                  style={{ width: "130px", height: "40px", marginTop: -5 }}
                />
              </a>
            </div>
          </div>
<div style={{display:'flex',justifyContent:'center'}}>
          <img
            src={mobileFooterNewImage}
            alt=""
            style={{ height: "80%",width:'88%',  objectFit:'contain' }}
          />
     </div>
        </div>
      </div>
      <div
        className="footer-new"
        style={{
          background:'transparent',
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "100%",
          // paddingTop:'25%'
        }}
      >
        <div className="contain" style={{ padding: "20px 0px 0px 0px" }}>
          <div
            className="col"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap:40
            }}
          >
            <p style={{margin:0}}>
              <FrankIcon fill={"#fff"} height={80} width={"128.98px"} />
            </p>
            <div
                style={{
                  display: "flex",
                   justifyContent: "flex-start",
                  alignItems: "flex-start",
                  flexDirection: "row",
                  maxWidth:'129px',
                  marginLeft:"55px",
                  marginTop:'-50px',
                  gap:10
                }}
              >
                <div
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/profile.php?id=61561661727623",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                  style={{
                    cursor: "pointer",
                    display: "inline-flex", // Ensure the image fills the div
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    
                    src={facebookIcon}
                    alt="facebook-icon"
                    style={{
                      width: "30px", // Make image fill the div
                      height: "30px", // Adjust height if needed
                      display: "block", // Remove gaps around the image
                      zIndex: "11111",
                    }}
                  />
                </div>

                <div
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/frankme.fr/",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                  style={{
                    cursor: "pointer",
                    display: "inline-flex", // Ensure the image fills the div
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                   
                    src={instaIcon}
                    alt="facebook-icon"
                    style={{
                      width: "30px", // Make image fill the div
                      height: "30px", // Adjust height if needed
                      display: "block", // Remove gaps around the image
                      zIndex: "11111",
                    }}
                  />
                </div>

                <div
                  onClick={() =>
                    
                    window.open(
                      "https://www.linkedin.com/company/fr-frank/",
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                  
                  style={{
                    cursor: "pointer",
                    display: "inline-flex",  
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                   
                    src={linkedInIcon}
                    alt="linkedin-icon"
                    style={{
                      width: "30px", // Make image fill the div
                      height: "30px", // Adjust height if needed
                      display: "block", // Remove gaps around the image
                      zIndex: "11111",
                    }}
                  />
                </div>
              </div>
          </div>
         

          <div className="col">
             
            <ul>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular" }} onClick={()=>{navigate("/send-package")}}>Envoyer un colis</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular"}} onClick={()=>{navigate("/transporter-un-colis")}}>Devenir transporteur</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular"}} onClick={()=>{navigate("/send-package")}}>Déménagement</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular"}} onClick={()=>{navigate("/faq")}}>FAQ</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular"}} onClick={()=>{navigate("/about-us")}}>Qui sommes nous ?</li>

            
            </ul>
          </div>

          <div className="col">
          <ul>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular" }} onClick={()=>{navigate("/announces")}}>Voir les annonces</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular"}} onClick={()=>{navigate("/profile")}}>Mon compte</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular"}} onClick={()=>{navigate("/chat")}}>Messagerie</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular"}} onClick={()=>{navigate("/blogs")}}>Blog</li>
 
            
            </ul>
          </div>
          <div className="col">
          <ul>
              <li style={{fontSize:'17px',color:'#ffffff',fontFamily:"montserrat-Regular",fontWeight:500 }}  >Nous contacter</li>
              <li
                style={{fontFamily:"montserrat-Regular",color:"#FFFFFFD9",fontSize:'17px' ,textDecoration:"none" }}

                 
                >
                  <a
                      style={{ textDecoration: "none", color: "#FFFFFFD9",fontSize:"17px",fontFamily:'montserrat-Regular' }}
                      href="mailto:hello@frankme.com"
                    >
                      hello@frankme.com
                    </a>
                </li>
                <li
                style={{fontFamily:"montserrat-Regular",color:"#FFFFFFD9",fontSize:'17px',opacity:"85%",textDecoration:'none'}}

                   
                >
                    <a
                      style={{ textDecoration: "none", color: "#FFFFFFD9" }}
                      href="tel:+33607948055"
                    >
                      {" "}
                      +33 6 07 94 80 55
                    </a>
                </li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular",margin:0,padding:0}} onClick={()=>{navigate("/privacy-policy")}}>Politique de confidentialité</li>
              <li style={{fontSize:'17px',color:'#FFFFFFD9',fontFamily:"montserrat-Regular",margin:0,padding:0}} onClick={()=>{navigate("/terms-and-condition")}}>Termes et conditions</li>

 
            
            </ul>
          </div>

          

          

          <div className="clearfix"></div>
        </div>
      </div>
    </div>
  );
}
